import { useContext, useEffect } from 'react';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { StepperDataContext } from './AddEditCustomer';

const MobileNumberRegistration = (props) => {
    const navigate = useNavigate();
    const {sendOtp} = props;
    const {otrDetails} = useContext(StepperDataContext)
    const {control,watch,handleSubmit,setValue,reset,formState:{errors}} = useForm({
        mode:'onChange',
        defaultValues:otrDetails
    });
    const handleMobileSubmit = async(data)=>{
        // sendOtp(data.mobile_number);
        sendOtp(data.mobileNumber);
    }
    useEffect(()=>{
        reset(otrDetails)
    },[otrDetails])
  return (
    <>               
        <Paper
            sx={{
                my: 8,
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p:'3%',
                borderRadius:'.75rem'
            }}
        >
            <Box sx={{textAlign:'left',width:'85%'}}>
                <Typography sx={{fontSize:'1rem',fontWeight:600}}>
                    Enter Mobile Number
                </Typography>
            </Box>
            <Box
                component="form"
                sx={{ mt: 1 ,width:'85%'}}
                textAlign={'center'}
                onSubmit={handleSubmit(handleMobileSubmit)}
            >
                <Controller
                    name='mobileNumber'
                    control={control}
                    rules={{
                        required: 'Mobile number is required',
                        pattern: {
                            value: /^[1-9][0-9]{9}$/,
                            message: "Enter a valid 10-digit number not starting with 0"
                        },
                        validate: (value) => {
                        if (value && value.length !== 10) {
                            return "Mobile number must be exactly 10 digits";
                        }
                        return true;
                        }
                    }}
                    render={({field,fieldState:{error}})=>(
                        <TextField
                            {...field}
                            fullWidth
                            type='number'
                            size='small'
                            // label="Mobile Number"
                            placeholder='1245678899'
                            autoFocus
                            error={!!error}
                            helperText={error && error?.message}
                            inputProps={{
                                maxLength: 10,
                                style:{
                                    fontSize:'0.65rem'
                                }
                            }}
                            onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                            field.onChange(value);
                            }}
                        />
                    )}
                />

                <Box sx={{textAlign:'center'}}>
                    <Button
                        type="submit"
                        size='small'
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 ,width:'fit-content',textTransform:'capitalize'}}
                        // onClick={sendOtp}
                        disabled={errors.mobileNumber}
                    >
                        Get Otp
                    </Button>
                </Box>
            </Box>
        </Paper>
    </>
  );
}

export default MobileNumberRegistration;
